export const deClientPortalUserSettingsSidebarPages = {
    settings: {
        userSettingsSidebar: {
            sidebar: {
                settings: 'Einstellungen',
                profile: 'Mein Profil',
                notifications: 'Benachrichtigungen',
            },
        },
    },
}
